/**
 * SEO utility to update page title and meta tags
 * This is a lightweight alternative to react-helmet for basic SEO needs
 */
export const updateSEO = ({ title, description, image, url }) => {
  // Update document title
  if (title) {
    document.title = title;
  }

  // Update meta description
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    document.head.appendChild(metaDescription);
  }
  if (description) {
    metaDescription.setAttribute('content', description);
  }

  // Update Open Graph tags
  const updateOGTag = (property, content) => {
    if (!content) return;
    let tag = document.querySelector(`meta[property="${property}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('property', property);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
  };

  if (title) updateOGTag('og:title', title);
  if (description) updateOGTag('og:description', description);
  if (url) updateOGTag('og:url', url);
  if (image) updateOGTag('og:image', image);

  // Update Twitter Card tags
  const updateTwitterTag = (name, content) => {
    if (!content) return;
    let tag = document.querySelector(`meta[name="${name}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', name);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
  };

  if (title) updateTwitterTag('twitter:title', title);
  if (description) updateTwitterTag('twitter:description', description);
  if (image) updateTwitterTag('twitter:image', image);

  // Update canonical URL
  let canonical = document.querySelector('link[rel="canonical"]');
  if (url) {
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }
};

